module.exports = __webpack_public_path__ + "1e20ac096899bf6f70304b784216e02f.svg";